<template>
  <div class="xq-page">
    <!-- 页面背景长图 -->
    <img
      style="width: 100%"
      src="../../assets/image/download/xq/index.png"
      alt=""
    />

    <!-- 视频展示区 -->
    <div class="video-div">
      <video
        controls
        loop
        poster="../../assets/image/download/xq/poster.png"
        src="../../assets/image/download/xq/movie.mp4"
      ></video>
    </div>

    <!-- 顶部下载按钮 -->
    <button class="headerButton animated infinite pulse" @click="downloadApp">
      <img
        src="../../assets/image/download/xq/download.png"
        alt="立即下载"
      />
    </button>

    <!-- 微信内引导遮罩 -->
    <section class="mask">
      <img src="../../assets/image/download/mask.png" alt="" />
    </section>

    <!-- 底部下载按钮 -->
    <button class="footerButton animated infinite pulse" @click="downloadApp">
      <img
        src="../../assets/image/download/xq/download.png"
        alt="立即下载"
      />
    </button>
  </div>
</template>

<script>
import { downloadApp as download } from "./common";

// 小晴同学 App 下载地址
const IOS_URL =
  "https://itunes.apple.com/cn/app/%E5%B0%8F%E6%99%B4%E5%90%8C%E5%AD%A6/id1619735568?mt=8";
const ANDROID_PACKAGE = "com.eletell.xq";

export default {
  name: "XqDownload",
  methods: {
    downloadApp() {
      // 原页面无埋点，不传 trackPageId
      download({ iosUrl: IOS_URL, androidPackage: ANDROID_PACKAGE });
    },
  },
};
</script>

<style scoped>
.xq-page {
  position: relative;
}
img {
  display: block;
}
.video-div {
  position: absolute;
  left: 50%;
  top: 190vw;
  width: 77.3vw;
  height: 44.3vw;
  margin-left: -38.65vw;
  overflow: hidden;
}
.video-div video {
  width: 100%;
  height: 100%;
}
.headerButton,
.footerButton {
  position: absolute;
  left: 50%;
  padding: 0;
  border: none;
  background: none;
}
.headerButton img,
.footerButton img {
  width: 100%;
}
.headerButton {
  top: 153vw;
  width: 70.4vw;
  margin-left: -35.2vw;
}
.footerButton {
  bottom: 5.8%;
  width: 80vw;
  margin-left: -40vw;
}
.mask {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.mask img {
  position: absolute;
  top: 2vw;
  right: 2vw;
  width: 75%;
}
</style>
